import React from 'react';
import { Flex } from 'antd';

import { ChatListContainer } from 'features/analytics/features/ChatList/containers/ChatListContainer';

import { MembersContainer } from './containers/MembersContainer';
import { MembersMultiLineChart } from './components/MembersMultiLineChart';
import { ActiveMembersChart } from './components/ActiveMembersChart';
import { useAppSelector } from '../../../../store';
import { selectAnalyticsFilters } from '../../store/analyticFiltersSlice';

export const AnalyticMembers = () => {
    const { chat } = useAppSelector(selectAnalyticsFilters);

    return (
        <Flex gap={16} vertical>
            <Flex gap={16}>
                <MembersMultiLineChart />

                <Flex flex='0 0 24%'>
                    <ActiveMembersChart />
                </Flex>
            </Flex>

            {chat ? <MembersContainer /> : <ChatListContainer />}
        </Flex>
    );
};
